module.exports = __webpack_public_path__ + "media/images/fonts/iconfont-1b1f60449f811b0c54959a7a48b8d856.ttf";